import { __read } from "tslib";
/**
 * 计算线段长度
 */
export function lineLen(_a, _b) {
    var _c = __read(_a, 2), x1 = _c[0], y1 = _c[1];
    var _d = __read(_b, 2), x2 = _d[0], y2 = _d[1];
    return Math.pow((Math.pow((x1 - x2), 2) + Math.pow((y1 - y2), 2)), 0.5);
}
//# sourceMappingURL=line-length.js.map